import { render } from "./bus.vue?vue&type=template&id=fb92a142"
import script from "./bus.vue?vue&type=script&lang=js"
export * from "./bus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__